"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[207,6321],{

/***/ 80348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export keyToIconNameMap */
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43474);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24959);






var keyToIconNameMap = {
    BESTSELLER: "48/bestseller",
    CHARITY: "48/charity",
    CLEAN: "48/clean",
    LIMITED_EDITION: "48/limited-time",
    NEW_ARRIVAL: "48/new",
    SOLD_OUT: "48/out-of-stock"
};
var ProductGraphicLabels = function(props) {
    var className = props.className, items = props.items, limit = props.limit;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    if (limit && items.length > limit) {
        items = items.slice(0, limit);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(className, "grid grid-cols-1 gap-16"),
        children: items.map(function(key) {
            return Boolean(keyToIconNameMap[key]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                className: "mx-auto",
                name: keyToIconNameMap[key],
                "aria-label": key
            }, key);
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.memo(ProductGraphicLabels));


/***/ }),

/***/ 82775:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductPrice_ProductPrice)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/ProductPrice/messages.ts
/* harmony default export */ const messages = ({
    old: {
        en: "Price reduced from"
    },
    "new": {
        en: "On sale at"
    }
});

;// CONCATENATED MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx







// TODO should we use currencyCode from data? - added on 14.01.2022 by sonatskiy
var ProductPrice = function(props) {
    var _data_discountPrice, _data_standardPrice;
    var className = props.className, data = props.data, formattedData = props.formattedData, _props_textStyle = props.textStyle, textStyle = _props_textStyle === void 0 ? "h8" : _props_textStyle, _props_oldPriceClassName = props.oldPriceClassName, oldPriceClassName = _props_oldPriceClassName === void 0 ? "font-normal" : _props_oldPriceClassName, _props_newPriceClassName = props.newPriceClassName, newPriceClassName = _props_newPriceClassName === void 0 ? "font-bold" : _props_newPriceClassName, _props_withNbsp = props.withNbsp, withNbsp = _props_withNbsp === void 0 ? true : _props_withNbsp;
    var intl = (0,useIntl/* default */.Z)();
    var discountPrice = data === null || data === void 0 ? void 0 : (_data_discountPrice = data.discountPrice) === null || _data_discountPrice === void 0 ? void 0 : _data_discountPrice.amount;
    var standardPrice = data === null || data === void 0 ? void 0 : (_data_standardPrice = data.standardPrice) === null || _data_standardPrice === void 0 ? void 0 : _data_standardPrice.amount;
    var finalPrice;
    var oldPrice;
    var oldPriceLabel;
    var newPriceLabel;
    if (formattedData) {
        var discountPrice1 = formattedData.discountPrice, standardPrice1 = formattedData.standardPrice;
        finalPrice = discountPrice1 || standardPrice1;
        if (finalPrice !== standardPrice1) {
            oldPrice = standardPrice1;
            oldPriceLabel = intl.formatMessage(messages.old);
            newPriceLabel = intl.formatMessage(messages["new"]);
        }
    } else {
        if (typeof discountPrice === "number") {
            // it's formatted as USD, not cents
            finalPrice = (0,formatPrice/* default */.Z)(discountPrice, {
                isCents: false
            });
            if (standardPrice > discountPrice) {
                oldPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                    isCents: false
                });
                oldPriceLabel = intl.formatMessage(messages.old);
                newPriceLabel = intl.formatMessage(messages["new"]);
            }
        } else if (typeof standardPrice === "number") {
            finalPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                isCents: false
            });
        }
    }
    if (!finalPrice) {
        return null;
    }
    if (oldPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
            className: className,
            style: textStyle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                    className: (0,clsx/* default */.Z)(oldPriceClassName),
                    "aria-label": oldPriceLabel,
                    "data-testid": "oldPrice",
                    children: oldPrice
                }),
                withNbsp && "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: (0,clsx/* default */.Z)(newPriceClassName),
                    "aria-label": newPriceLabel,
                    "data-testid": "price",
                    children: finalPrice
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: (0,clsx/* default */.Z)(className, newPriceClassName),
        style: textStyle,
        "data-testid": "price",
        children: finalPrice
    });
};
/* harmony default export */ const ProductPrice_ProductPrice = (/*#__PURE__*/react.memo(ProductPrice));


/***/ }),

/***/ 29492:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ CartModal_CartModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.parse-float.js
var es_parse_float = __webpack_require__(96912);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(8055);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(41964);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(26368);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(36654);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/modules/cart/index.ts + 4 modules
var modules_cart = __webpack_require__(65337);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/feedback/ModalHeadline/ModalHeadline.tsx
var ModalHeadline = __webpack_require__(45413);
// EXTERNAL MODULE: ./src/components/feedback/ModalButtons/ModalButtons.tsx
var ModalButtons = __webpack_require__(95325);
// EXTERNAL MODULE: ./src/components/feedback/ModalWithLayers/ModalWithLayers.tsx + 4 modules
var ModalWithLayers = __webpack_require__(99687);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/modals/FirstProductModal/FirstProductModal.tsx + 1 modules
var FirstProductModal = __webpack_require__(74451);
// EXTERNAL MODULE: ./src/compositions/orderItems/util/useOrderBill.ts + 1 modules
var useOrderBill = __webpack_require__(31580);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderBillItem/OrderBillItem.tsx
var OrderBillItem = __webpack_require__(97293);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ./src/compositions/orderItems/SubscriptionOrderItem/SubscriptionOrderItem.tsx + 4 modules
var SubscriptionOrderItem = __webpack_require__(12278);
// EXTERNAL MODULE: ./src/compositions/orderItems/GiftSubscriptionOrderItem/GiftSubscriptionOrderItem.tsx + 1 modules
var GiftSubscriptionOrderItem = __webpack_require__(90549);
// EXTERNAL MODULE: ./src/compositions/orderItems/GiftCardOrderItem/GiftCardOrderItem.tsx + 1 modules
var GiftCardOrderItem = __webpack_require__(26163);
// EXTERNAL MODULE: ./src/compositions/orderItems/GiftSubscriptionOfferOrderItem/GiftSubscriptionOfferOrderItem.tsx
var GiftSubscriptionOfferOrderItem = __webpack_require__(31192);
// EXTERNAL MODULE: ./src/compositions/orderItems/index.tsx
var orderItems = __webpack_require__(92167);
// EXTERNAL MODULE: ./src/compositions/orderItems/ProductOrderItem/ProductOrderItem.tsx + 6 modules
var ProductOrderItem = __webpack_require__(30852);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(5649);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83901);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(7138);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx + 1 modules
var ProductPrice = __webpack_require__(82775);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(28625);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(6493);
;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionBanner/messages.ts
/* harmony default export */ const SubscriptionBanner_messages = ({
    title: {
        en: "Would you like to add a monthly fragrance subscription?"
    },
    course: {
        title: {
            en: '\n        <span class="text-gold-50">Save on this course</span> with a <br /> Scentbird subscription.\n      '
        }
    },
    text: {
        en: "\n      A month-to-month subscription to Scentbird. Billed monthly,\n      renews automatically.\n    "
    },
    emptyProduct: {
        en: "\n      Your choice of one 8ml fragrance a month, with a free case included\n    "
    },
    no: {
        en: "No thanks"
    },
    yes: {
        en: "Yes, add it!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionBanner/SubscriptionBanner.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}














var SubscriptionBanner = function(props) {
    var className = props.className, onCancel = props.onCancel, hasAcademyCourse = props.hasAcademyCourse;
    var _useSubscribeOffer = (0,subscribe/* useSubscribeOffer */.Hu)(), formattedPrice = _useSubscribeOffer.formattedPrice, formattedPriceWithDiscount = _useSubscribeOffer.formattedPriceWithDiscount, offerType = _useSubscribeOffer.offerType, couponCode = _useSubscribeOffer.couponCode, eventDiscountText = _useSubscribeOffer.eventDiscountText, handleSubscribeClick = _useSubscribeOffer.handleSubscribeClick;
    var _useCartModify = _sliced_to_array((0,modules_cart/* useCartModify */.sd)(), 2), submit = _useCartModify[0], _useCartModify_ = _useCartModify[1], isSubmitting = _useCartModify_.isFetching;
    var isSubCartOfferEnabled = offerType === "discount";
    var trackParams = isSubCartOfferEnabled ? {
        discount: eventDiscountText,
        coupon: couponCode
    } : {};
    var handleConfirmClick = function() {
        var _ref = _async_to_generator(function() {
            var _getAnalyticsContext, page, pageType, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isSubCartOfferEnabled) {
                            // apply coupon
                            handleSubscribeClick();
                        }
                        if (!hasAcademyCourse) return [
                            3,
                            5
                        ];
                        (0,analytics/* track */.j)("Banner click", _object_spread({
                            placement: "Cart",
                            content: "Subscribe",
                            action: "Add to cart"
                        }, trackParams));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _getAnalyticsContext = (0,context/* getAnalyticsContext */.cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
                        return [
                            4,
                            submit({
                                subscriptionItem: {
                                    plan: "MONTHLY"
                                },
                                metadata: {
                                    page: page,
                                    pageType: pageType
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        (0,errors/* processError */.wY)(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        (0,analytics/* track */.j)("Banner click", _object_spread({
                            placement: "Cart",
                            content: "Subscribe",
                            action: "link",
                            link: links/* default */.ZP.subscribe
                        }, trackParams));
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var priceNode = isSubCartOfferEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
        className: "flex flex-col items-end",
        textStyle: "p2",
        withNbsp: false,
        formattedData: {
            discountPrice: formattedPriceWithDiscount,
            standardPrice: formattedPrice
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        "data-testid": "subscriptionBanner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h7",
                message: hasAcademyCourse ? SubscriptionBanner_messages.course.title : SubscriptionBanner_messages.title,
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
                className: "mt-16",
                "data-testid": "subscriptionBannerItem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "p2",
                        message: SubscriptionBanner_messages.text,
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
                        className: "mt-24",
                        price: isSubCartOfferEnabled ? undefined : formattedPrice,
                        priceNode: priceNode,
                        "data-testid": "subscriptionCase",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "p2",
                            message: SubscriptionBanner_messages.emptyProduct
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-40 flex justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: 38,
                                style: "secondary",
                                title: SubscriptionBanner_messages.no,
                                disabled: isSubmitting,
                                onClick: onCancel,
                                "data-testid": "cancelButton"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "ml-12",
                                size: 38,
                                style: "primary",
                                title: SubscriptionBanner_messages.yes,
                                to: hasAcademyCourse ? undefined : links/* default */.ZP.subscribe,
                                loading: isSubmitting,
                                onClick: handleConfirmClick,
                                "data-testid": "confirmButton"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const SubscriptionBanner_SubscriptionBanner = (/*#__PURE__*/react.memo(SubscriptionBanner));

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(54939);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(14939);
;// CONCATENATED MODULE: ./src/compositions/orderItems/GiftSubscriptionBanner/messages.ts
/* harmony default export */ const GiftSubscriptionBanner_messages = ({
    title: {
        en: "Would you like to add a Scentbird subscription for yourself?"
    },
    no: {
        en: "No thanks"
    },
    yes: {
        en: "Yes, add it!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/GiftSubscriptionBanner/GiftSubscriptionBanner.tsx
function GiftSubscriptionBanner_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GiftSubscriptionBanner_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GiftSubscriptionBanner_define_property(target, key, source[key]);
        });
    }
    return target;
}












var GiftSubscriptionBanner = function(props) {
    var className = props.className, data = props.data, onCancel = props.onCancel;
    var description = data.description, image = data.image, priceOfferText = data.priceOfferText, whatYouAreGetting = data.whatYouAreGetting;
    var _useSubscribeOffer = (0,subscribe/* useSubscribeOffer */.Hu)(), couponCode = _useSubscribeOffer.couponCode, eventDiscountText = _useSubscribeOffer.eventDiscountText, handleSubscribeClick = _useSubscribeOffer.handleSubscribeClick, offerType = _useSubscribeOffer.offerType;
    var isSubCartOfferEnabled = offerType === "discount";
    var trackParams = isSubCartOfferEnabled ? {
        discount: eventDiscountText,
        coupon: couponCode
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        "data-testid": "giftSubscriptionOfferBanner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h7",
                message: GiftSubscriptionBanner_messages.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
                className: "mt-16",
                "data-testid": "giftSubscriptionOfferBannerItem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "p2",
                        message: whatYouAreGetting
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
                        className: "mt-24",
                        image: image,
                        rebrandImage: image,
                        priceNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: priceOfferText,
                            style: "t2"
                        }),
                        "data-testid": "giftSubscriptionOfferCase",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "p2",
                            message: description
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-40 flex justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: 38,
                                style: "secondary",
                                title: GiftSubscriptionBanner_messages.no,
                                onClick: onCancel,
                                "data-testid": "cancelButton"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "ml-12",
                                size: 38,
                                style: "primary",
                                title: GiftSubscriptionBanner_messages.yes,
                                to: links/* default */.ZP.subscribe,
                                onClick: function() {
                                    (0,analytics/* track */.j)("Banner click", GiftSubscriptionBanner_object_spread({
                                        placement: "Cart",
                                        content: "Subscribe",
                                        action: "link",
                                        link: links/* default */.ZP.subscribe
                                    }, trackParams));
                                    if (isSubCartOfferEnabled) {
                                        // apply coupon
                                        handleSubscribeClick();
                                    }
                                },
                                "data-testid": "confirmButton"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const GiftSubscriptionBanner_GiftSubscriptionBanner = (/*#__PURE__*/react.memo(GiftSubscriptionBanner));

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__(73074);
// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(55222);
// EXTERNAL MODULE: ./local_modules/date/difference.ts
var difference = __webpack_require__(97993);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/modules/user/shownPopups/index.tsx + 2 modules
var user_shownPopups = __webpack_require__(86506);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/compositions/orderItems/util/useOrderItems.ts
var useOrderItems = __webpack_require__(11748);
;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/CartItems/util/useCartItems.ts
function useCartItems_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useCartItems_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function useCartItems_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useCartItems_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useCartItems_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useCartItems_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useCartItems_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useCartItems_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useCartItems_sliced_to_array(arr, i) {
    return useCartItems_array_with_holes(arr) || useCartItems_iterable_to_array_limit(arr, i) || useCartItems_unsupported_iterable_to_array(arr, i) || useCartItems_non_iterable_rest();
}
function useCartItems_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useCartItems_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useCartItems_array_like_to_array(o, minLen);
}
function useCartItems_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}











var useCartItems = function(cart) {
    var orderItems = (0,useOrderItems/* default */.Z)(cart);
    var isGiftSubscriptionOfferEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftSubscriptionOffer);
    var subscription = (0,subscription_subscription/* useSubscription */.m)().subscription;
    var shownPopups = (0,user_shownPopups/* useShownPopups */.BP)().shownPopups;
    var isLoggedIn = (0,user/* useUser */.a)().isLoggedIn;
    var setPopupShown = (0,user_shownPopups/* useSetPopupShown */.aw)();
    var subscriptionBannerWasShownInSession = local_storage/* default */.Z.getSessionItem(constants/* default */.Z.localStorageNames.cartSubscriptionBanner);
    var _useState = useCartItems_sliced_to_array((0,react.useState)(false), 2), courseSubscriptionBannerWasShown = _useState[0], setCourseSubscriptionBannerWasShown = _useState[1];
    var _useState1 = useCartItems_sliced_to_array((0,react.useState)(false), 2), giftSubscriptionBannerWasShown = _useState1[0], setGiftSubscriptionBannerWasShown = _useState1[1];
    var offerSubscription = Boolean((subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) && !orderItems.subscription);
    var isSubscriptionBannerEnabled = offerSubscription && (isGiftSubscriptionOfferEnabled ? !orderItems.giftSubscriptionOffer : true);
    var isGiftSubscriptionBannerEnabled = offerSubscription && (isGiftSubscriptionOfferEnabled ? orderItems.giftSubscriptionOffer : false);
    var hasAcademyCourse = orderItems.products.some(function(product) {
        return product.type === "AcademyCourse";
    });
    var giftSubscriptionBanner = (0,react.useMemo)(function() {
        if (!isGiftSubscriptionBannerEnabled || giftSubscriptionBannerWasShown) {
            return null;
        }
        return {
            onCancel: function() {
                setGiftSubscriptionBannerWasShown(true);
            }
        };
    }, [
        isGiftSubscriptionBannerEnabled,
        giftSubscriptionBannerWasShown
    ]);
    var subscriptionBanner = (0,react.useMemo)(function() {
        var _shownPopups_cartSubscriptionBanner;
        if (!isSubscriptionBannerEnabled) {
            return null;
        }
        if (hasAcademyCourse) {
            if (courseSubscriptionBannerWasShown) {
                return null;
            }
            return {
                onCancel: function() {
                    setCourseSubscriptionBannerWasShown(true);
                }
            };
        }
        if (subscriptionBannerWasShownInSession) {
            return null;
        }
        var lastUpdated = (_shownPopups_cartSubscriptionBanner = shownPopups["cartSubscriptionBanner"]) === null || _shownPopups_cartSubscriptionBanner === void 0 ? void 0 : _shownPopups_cartSubscriptionBanner.lastUpdated;
        // hide popup for 24 hours
        if (lastUpdated && (0,difference/* getElapsedTime */.q)(lastUpdated, "hours") < 24) {
            return null;
        }
        return {
            onCancel: /*#__PURE__*/ useCartItems_async_to_generator(function() {
                var error;
                return useCartItems_ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            if (!isLoggedIn) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                setPopupShown("cartSubscriptionBanner")
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            local_storage/* default */.Z.setSessionItem(constants/* default */.Z.localStorageNames.cartSubscriptionBanner, true);
                            setCourseSubscriptionBannerWasShown(true);
                            _state.label = 3;
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            (0,errors/* processError */.wY)(error);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            })
        };
    }, [
        isLoggedIn,
        setPopupShown,
        isSubscriptionBannerEnabled,
        hasAcademyCourse,
        subscriptionBannerWasShownInSession,
        shownPopups,
        courseSubscriptionBannerWasShown
    ]);
    return {
        orderItems: orderItems,
        giftSubscriptionBanner: giftSubscriptionBanner,
        subscriptionBanner: subscriptionBanner,
        hasAcademyCourse: hasAcademyCourse
    };
};
/* harmony default export */ const util_useCartItems = (useCartItems);

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/CartItems/CartItems.tsx
function CartItems_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CartItems_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CartItems_define_property(target, key, source[key]);
        });
    }
    return target;
}






var CartItems = function(props) {
    var className = props.className, cart = props.cart;
    var _useCartItems = util_useCartItems(cart), _useCartItems_orderItems = _useCartItems.orderItems, giftCard = _useCartItems_orderItems.giftCard, giftSubscription = _useCartItems_orderItems.giftSubscription, giftSubscriptionOffer = _useCartItems_orderItems.giftSubscriptionOffer, limitedDrops = _useCartItems_orderItems.limitedDrops, products = _useCartItems_orderItems.products, subscription = _useCartItems_orderItems.subscription, subscriptionBanner = _useCartItems.subscriptionBanner, giftSubscriptionBanner = _useCartItems.giftSubscriptionBanner, hasAcademyCourse = _useCartItems.hasAcademyCourse;
    var hasFirstItem = false;
    var getClassName = function() {
        if (hasFirstItem) {
            return "mt-16";
        }
        hasFirstItem = true;
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            Boolean(subscription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionOrderItem/* default */.Z, {
                className: getClassName(),
                data: subscription,
                giftSubscriptionOffer: giftSubscriptionOffer,
                withRemoveButton: true
            }),
            Boolean(giftSubscription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionOrderItem/* default */.Z, {
                className: getClassName(),
                data: giftSubscription,
                withRemoveButton: true
            }),
            Boolean(giftCard) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftCardOrderItem/* default */.Z, {
                className: getClassName(),
                data: giftCard,
                withRemoveButton: true
            }),
            Boolean(giftSubscriptionOffer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionOfferOrderItem/* default */.Z, {
                className: getClassName(),
                data: giftSubscriptionOffer
            }),
            limitedDrops === null || limitedDrops === void 0 ? void 0 : limitedDrops.map(function(item) {
                var id = item.id;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(orderItems/* LimitedDropOrderItem */.FX, {
                    className: getClassName(),
                    data: item,
                    placement: "cart"
                }, id);
            }),
            products === null || products === void 0 ? void 0 : products.map(function(item) {
                var drift = item.drift, id = item.id, isRemovable = item.isRemovable, size = item.size;
                var _$props = {
                    className: getClassName(),
                    data: item,
                    key: "".concat(id, "-").concat(size, "-").concat(drift === null || drift === void 0 ? void 0 : drift.starterSet),
                    withRemoveButton: isRemovable
                };
                if (drift) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(orderItems/* DriftOrderItem */.Wq, CartItems_object_spread({}, _$props));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOrderItem/* default */.Z, CartItems_object_spread({}, _$props));
            }),
            Boolean(subscriptionBanner) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionBanner_SubscriptionBanner, {
                className: getClassName(),
                onCancel: subscriptionBanner.onCancel,
                hasAcademyCourse: hasAcademyCourse
            }),
            Boolean(giftSubscriptionBanner) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionBanner_GiftSubscriptionBanner, {
                className: getClassName(),
                data: giftSubscriptionOffer,
                onCancel: giftSubscriptionBanner.onCancel
            })
        ]
    });
};
/* harmony default export */ const CartItems_CartItems = (CartItems);

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/CartBill/CartBill.tsx






var CartBill = function(props) {
    var className = props.className, bill = props.bill;
    var isStickyCtaEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.ecomCartStickyCta) === "b";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: bill.map(function(item, index) {
            var label = item.label, note = item.note, value = item.value, isSubTotal = item.isSubTotal, isTotal = item.isTotal, dataTestId = item.dataTestId;
            if (isStickyCtaEnabled && isTotal) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBillItem/* default */.Z, {
                className: index ? "mt-16" : null,
                label: label,
                note: note,
                value: value,
                isLarge: isSubTotal || isTotal,
                "data-testid": dataTestId
            }, index);
        })
    });
};
/* harmony default export */ const CartBill_CartBill = (CartBill);

// EXTERNAL MODULE: ./src/modules/products/useProductGiftPromo.ts + 1 modules
var useProductGiftPromo = __webpack_require__(78053);
// EXTERNAL MODULE: ./src/components/dataDisplay/Progress/Progress.tsx
var Progress = __webpack_require__(54592);
;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/GiftWithSpendThresholdProgress/messages.ts
/* harmony default export */ const GiftWithSpendThresholdProgress_messages = ({
    "default": {
        remain: {
            en: '\n        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from\n        <span class="text-gold-50 font-bold">free Scentbird travel Bag</span>\n      '
        },
        earned: {
            en: 'You\'ve earned a <span class="text-gold-50 font-bold">free Scentbird travel Bag</span>'
        },
        description: {
            en: "\n        Eligible customers will receive a Scentbird travel Bag\n        for free with any ecommerce purchase of {subTotal} or more.\n        While supplies last. Offer applied automatically at checkout.\n      "
        }
    },
    fathersDay: {
        remain: {
            en: '\n        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from\n        <span class="text-gold-50 font-bold">FREE gift!</span>\n      '
        },
        earned: {
            en: 'You\'ve earned a <span class="text-gold-50 font-bold">FREE GIFT</span>'
        },
        description: {
            en: "\n        Eligible customers will receive a free Confessions of a Rebel GET A ROOM Body Wash\n        with any ecommerce purchase of {subTotal} or more.\n        While supplies last. Offer applied automatically at checkout.\n      "
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/GiftWithSpendThresholdProgress/GiftWithSpendThresholdProgress.tsx
function GiftWithSpendThresholdProgress_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function GiftWithSpendThresholdProgress_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            GiftWithSpendThresholdProgress_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var getSpendThresholdMessage = function(messagesData, remain) {
    if (remain === 0) {
        return messagesData.earned;
    }
    if (remain > 0) {
        return _object_spread_props(GiftWithSpendThresholdProgress_object_spread({}, messagesData.remain), {
            values: {
                remain: (0,formatPrice/* default */.Z)(remain)
            }
        });
    }
    return null;
};
var GiftWithSpendThresholdProgress = function(props) {
    var _cart_purchaseProgress_ecommercePromoProgress, _cart_purchaseProgress;
    var className = props.className;
    var cart = (0,modules_cart/* useCartContext */.iQ)().cart;
    var isHolidayFathersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayFathersDay);
    var _useProductGiftPromo = (0,useProductGiftPromo/* default */.Z)(), subTotal = _useProductGiftPromo.subTotal, isFetching = _useProductGiftPromo.isFetching;
    var ecommercePromoProgress = cart === null || cart === void 0 ? void 0 : (_cart_purchaseProgress = cart.purchaseProgress) === null || _cart_purchaseProgress === void 0 ? void 0 : (_cart_purchaseProgress_ecommercePromoProgress = _cart_purchaseProgress.ecommercePromoProgress) === null || _cart_purchaseProgress_ecommercePromoProgress === void 0 ? void 0 : _cart_purchaseProgress_ecommercePromoProgress[0];
    if (!ecommercePromoProgress) {
        return null;
    }
    var freeEcommercePromoGoal = ecommercePromoProgress.freeEcommercePromoGoal, freeEcommercePromoProgress = ecommercePromoProgress.freeEcommercePromoProgress, freeEcommercePromoRemain = ecommercePromoProgress.freeEcommercePromoRemain;
    var messagesData = isHolidayFathersDayEnabled ? GiftWithSpendThresholdProgress_messages.fathersDay : GiftWithSpendThresholdProgress_messages["default"];
    var message = getSpendThresholdMessage(messagesData, freeEcommercePromoRemain);
    var progress = freeEcommercePromoRemain ? freeEcommercePromoProgress / freeEcommercePromoGoal * 100 : 100;
    if (!message) {
        return null;
    }
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
            className: className,
            pw: 100,
            h: 148
        });
    }
    if (!subTotal) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
        className: className,
        message: message,
        progress: progress,
        textStyle: "p2",
        "data-testid": "giftWithSpentThreshold",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            className: "mb-24 mt-8",
            message: _object_spread_props(GiftWithSpendThresholdProgress_object_spread({}, messagesData.description), {
                values: {
                    subTotal: (0,formatPrice/* default */.Z)(subTotal.amountCents, {
                        removeZeroCents: true
                    })
                }
            }),
            style: "p5"
        })
    });
};
/* harmony default export */ const GiftWithSpendThresholdProgress_GiftWithSpendThresholdProgress = (GiftWithSpendThresholdProgress);

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/ShippingStatus/messages.ts
/* harmony default export */ const ShippingStatus_messages = ({
    remain: {
        en: 'Add <b class="text-gold-50">{remain}</b> to your order for <b class="uppercase text-gold-50">Free shipping</b>'
    },
    qualify: {
        en: 'You now qualify for <b class="uppercase text-gold-50">Free shipping</b>'
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/ShippingStatus/ShippingStatus.tsx
function ShippingStatus_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ShippingStatus_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ShippingStatus_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ShippingStatus_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ShippingStatus_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ShippingStatus_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var ShippingStatus = function(props) {
    var _cart_shipping, _cart_shipping1;
    var className = props.className, cart = props.cart;
    // we should use ecommerce item with is the last one
    var shipping = cart === null || cart === void 0 ? void 0 : (_cart_shipping1 = cart.shipping) === null || _cart_shipping1 === void 0 ? void 0 : _cart_shipping1[(cart === null || cart === void 0 ? void 0 : (_cart_shipping = cart.shipping) === null || _cart_shipping === void 0 ? void 0 : _cart_shipping.length) - 1];
    if (!shipping) {
        return null;
    }
    var freeShippingRemain = shipping.freeShippingRemain, price = shipping.price;
    var message = null;
    if (freeShippingRemain === 0 && price === 0) {
        // because Canadian users have to paid for subscription shipping, we should check, that shipping is actually free
        message = ShippingStatus_messages.qualify;
    } else if (freeShippingRemain > 0) {
        message = ShippingStatus_object_spread_props(ShippingStatus_object_spread({}, ShippingStatus_messages.remain), {
            values: {
                remain: (0,formatPrice/* default */.Z)(shipping.freeShippingRemain)
            }
        });
    } else {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: (0,clsx/* default */.Z)(className, "text-center"),
        style: "p4",
        message: message,
        html: true
    });
};
/* harmony default export */ const ShippingStatus_ShippingStatus = (ShippingStatus);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(56690);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(17696);
// EXTERNAL MODULE: ./src/components/dataDisplay/Label/Label.tsx + 1 modules
var Label = __webpack_require__(10016);
// EXTERNAL MODULE: ./src/components/inputs/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(79230);
;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/BundlingBanner/messages.ts
/* harmony default export */ const BundlingBanner_messages = ({
    label: {
        en: "New at Scentbird"
    },
    supTitle: {
        en: "Buy any 4 travel-size fragrances"
    },
    title: {
        en: "Get the 5th free"
    },
    addMore: {
        en: "Add {count, select, 1 {one} 2 {two} 3 {three} 4 {four}} more travel-size {count, plural, one {fragrance} other {fragrances}} to your cart."
    },
    qualify: {
        en: "You qualify for a free fragrance!"
    },
    congrats: {
        en: "Congrats, your reward has been applied to your cart!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/BundlingBanner/BundlingBanner.tsx
function BundlingBanner_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BundlingBanner_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BundlingBanner_define_property(target, key, source[key]);
        });
    }
    return target;
}
function BundlingBanner_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function BundlingBanner_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        BundlingBanner_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var BundlingBanner = function(props) {
    var className = props.className;
    var cart = (0,modules_cart/* useCartContext */.iQ)().cart;
    var qualifiedProducts = Number(cart === null || cart === void 0 ? void 0 : cart.countByFutureDiscount[constants/* default */.Z.discounts.buy5pay4]);
    var gender = (0,user/* useUser */.a)().gender;
    var link = gender === "FEMALE" ? links/* default */.ZP.shop.travelSize.perfumes : links/* default */.ZP.shop.travelSize.colognes;
    var handleClick = function() {
        (0,analytics/* track */.j)("Banner click", {
            content: "Get the 5th free",
            action: "link",
            link: link,
            placement: "Cart"
        });
    };
    // hide if there is no qualified products in the cart
    if (!qualifiedProducts) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)("relative rounded border border-solid border-gray-30 bg-white px-16 pb-16 pt-32", className),
        "data-testid": "bundlingBanner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.ZP, {
                className: "-left-8 -top-8",
                absolute: true,
                bgColor: "gold-30",
                textColor: "black",
                title: BundlingBanner_messages.label,
                withTail: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h8",
                message: BundlingBanner_messages.supTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-4",
                style: "h3",
                color: "gold-50",
                message: BundlingBanner_messages.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                className: "mt-8 font-bold",
                style: "p4",
                color: "gold-70",
                children: [
                    qualifiedProducts === 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                value: BundlingBanner_messages.qualify
                            }),
                            " "
                        ]
                    }),
                    qualifiedProducts >= 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: BundlingBanner_messages.congrats
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: BundlingBanner_object_spread_props(BundlingBanner_object_spread({}, BundlingBanner_messages.addMore), {
                            values: {
                                count: 5 - qualifiedProducts
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                    style: "black",
                    title: messages/* default */.Z.shopNow,
                    to: link,
                    onClick: handleClick
                })
            })
        ]
    });
};
/* harmony default export */ const BundlingBanner_BundlingBanner = (/*#__PURE__*/(0,react.memo)(BundlingBanner));

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/messages.ts
/* harmony default export */ const CartModal_messages = ({
    empty: {
        title: {
            en: "Your cart"
        },
        text: {
            en: "Your cart is empty"
        }
    },
    "default": {
        title: {
            en: "Your cart total - {total}"
        },
        text: {
            en: "Let’s review your cart..."
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/CartModal.tsx
function CartModal_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CartModal_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CartModal_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CartModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CartModal_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CartModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
































var isFullBottle = function(volume, unit) {
    try {
        var parsedVolume = parseFloat(volume);
        if (unit === "ml") {
            return parsedVolume > 8;
        }
        if (unit === "oz") {
            return parsedVolume > 0.27;
        }
    } catch (error) {}
    return false;
};
var CartModalView = function(param) {
    var flow = param.flow;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var cartContext = (0,modules_cart/* useCart */.jD)();
    var cart = cartContext.cart, isFetching = cartContext.isFetching;
    var isGwpSpendThresholdEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.gwpSpendThreshold);
    var isBuy5Pay4Enabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.buy5pay4);
    var isStickyCtaEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.ecomCartStickyCta) === "b";
    var _ref = cart || {}, discounts = _ref.discounts, shipping = _ref.shipping, credits = _ref.credits, subTotal = _ref.subTotal, total = _ref.total;
    var bill = (0,useOrderBill/* default */.Z)({
        discounts: discounts,
        shipping: shipping,
        credits: credits,
        subTotal: subTotal,
        total: total
    });
    var totalOrderItem = bill.find(function(item) {
        return item.isTotal;
    });
    // fire only once after open and fetching
    var isCartDisplayFiredRef = (0,react.useRef)(false);
    var isEmpty = !cart || cart.isEmpty;
    (0,react.useEffect)(function() {
        if (!cart || isCartDisplayFiredRef.current) {
            return;
        }
        isCartDisplayFiredRef.current = true;
        var productType = new Set();
        // TODO remove later, when we collect data in productType - added on 2023-10-10 by maddoger
        var ecommerceType = new Set();
        if (cart.hasSubscription) {
            productType.add("Perfume subscription");
        }
        if (cart.hasGiftSubscription) {
            productType.add("Gift subscription");
        }
        if (cart.hasGiftCard) {
            productType.add("Gift card");
        }
        if (cart.hasQueueItems) {
            productType.add("Buy queue");
            ecommerceType.add("Buy queue");
        }
        if (cart.hasLimitedDrops) {
            productType.add("Limited drop");
        }
        if (cart.hasProducts) {
            cart.products.forEach(function(param) {
                var product = param.product, offer = param.offer, price = param.price;
                var volume = product.volume, unit = product.unit;
                var typeGroup = product.typeGroup;
                if (offer === "TOSSIN" || offer === "TOSSIN_EMAIL") {
                    productType.add("Toss-in");
                    ecommerceType.add("Toss-in");
                } else if (price === 0) {
                    return;
                } else if (typeGroup === "PerfumeCase" || typeGroup === "FragranceStorageBox") {
                    productType.add("Ecommerce");
                    ecommerceType.add("Extras");
                } else if (typeGroup === "FlashSale") {
                    productType.add("Private sale");
                    ecommerceType.add("Flash sale");
                } else if (typeGroup === "AcademyCourse") {
                    productType.add("Scentbird Academy");
                } else if (typeGroup === "Perfume" && isFullBottle(volume, unit)) {
                    productType.add("Ecommerce");
                    ecommerceType.add("Full-size bottles");
                } else {
                    productType.add("Ecommerce");
                    ecommerceType.add("A la carte");
                }
            });
        }
        (0,analytics/* track */.j)("Cart display", {
            flow: flow,
            productType: Array.from(productType).sort(),
            ecommerceType: Array.from(ecommerceType).sort()
        });
    }, [
        isEmpty,
        flow,
        cart
    ]);
    var title = isEmpty ? CartModal_messages.empty.title : CartModal_object_spread_props(CartModal_object_spread({}, CartModal_messages["default"].title), {
        values: {
            total: (0,formatPrice/* default */.Z)(cart.total)
        }
    });
    var text = isEmpty ? CartModal_messages.empty.text : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modules_cart/* CartContextProvider */.GN, {
        value: cartContext,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeadline/* default */.Z, {
                title: title,
                text: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-1 flex-col items-stretch justify-start",
                children: !cart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                    pw: 100,
                    h: 100
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isEmpty && isGwpSpendThresholdEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftWithSpendThresholdProgress_GiftWithSpendThresholdProgress, {
                            className: "mb-32"
                        }),
                        !isEmpty && isBuy5Pay4Enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlingBanner_BundlingBanner, {
                            className: "mb-32"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItems_CartItems, {
                            cart: cart
                        }),
                        !isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBill_CartBill, {
                            className: "mt-32",
                            bill: bill
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)(isStickyCtaEnabled && "sticky bottom-0 mt-24 border-t border-gray-30 bg-white pb-40 ".concat(isMobile ? "-mx-16 -mb-16 px-16" : "-mx-40 -mb-40 px-40")),
                children: [
                    isStickyCtaEnabled && totalOrderItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBillItem/* default */.Z, {
                        className: "mt-16",
                        label: totalOrderItem.label,
                        note: totalOrderItem.note,
                        value: totalOrderItem.value,
                        isLarge: true,
                        "data-testid": totalOrderItem.dataTestId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButtons/* default */.Z, {
                        className: isStickyCtaEnabled ? "mt-16" : "",
                        withMargin: !isStickyCtaEnabled,
                        primary: {
                            title: messages/* default */.Z.checkout,
                            to: links/* default */.ZP.checkout,
                            disabled: isEmpty || isFetching,
                            loading: isFetching,
                            fullWidth: true
                        }
                    }),
                    !isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingStatus_ShippingStatus, {
                        className: "mt-16",
                        cart: cart
                    })
                ]
            })
        ]
    });
};
var FirstProductModalLayer = function() {
    var _useModalWithLayers = (0,ModalWithLayers/* useModalWithLayers */.y)(), activeLayers = _useModalWithLayers.activeLayers, closeLayer = _useModalWithLayers.closeLayer;
    var layerId = "firstProduct";
    var handleClose = (0,react.useCallback)(function() {
        closeLayer(layerId);
    }, [
        closeLayer,
        layerId
    ]);
    var layerProps = (activeLayers === null || activeLayers === void 0 ? void 0 : activeLayers.get(layerId)) || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithLayers/* default */.Z.Layer, {
        id: layerId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstProductModal.FirstProductModalView, CartModal_object_spread_props(CartModal_object_spread({}, layerProps), {
            closeModal: handleClose
        }))
    });
};
var CartModal = function(param) {
    var name = param.name, flow = param.flow, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalWithLayers/* default */.Z, {
        type: "sidebar-right",
        underMobileHeader: true,
        closeModal: closeModal,
        "data-testid": name,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartModalView, {
                flow: flow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstProductModalLayer, {})
        ]
    });
};
/* harmony default export */ const CartModal_CartModal = (CartModal);


/***/ })

}]);